import React from 'react'

export default function ContainerTwo() {
    return (
        <div className="container2 tw-flex tw-flex-col tw-w-full tw-gap-4">
            <div
                className="cs-card"
                style={{
                    padding: '24px',
                }}
            >
                <div className="tw-mb-4">
                    <p className="tw-text-primary tw-font-bold">Hot Bed Only</p>
                    <div className="tw-flex tw-flex-row tw-gap-2 tw-ml-2">
                        <div className='tw-flex'>
                            <span
                                className="tw-bg-primary bullet"
                                style={{
                                    borderRadius: '9999px',
                                    width: '6px',
                                    height: '6px',
                                    marginTop: '8px'
                                }}
                            ></span>
                        </div>
                        <p className="tw-text-primary">When hot bed dates are blocked, those selected dates for hot bed will be blocked.</p>
                    </div>
                </div>
                <div className="tw-mb-4">
                    <p className="tw-text-primary tw-font-bold">Cold Bed Only</p>
                    <div className="tw-flex tw-flex-row tw-gap-2 tw-ml-2">
                        <div className='tw-flex'>
                            <span
                                className="tw-bg-primary bullet"
                                style={{
                                    borderRadius: '9999px',
                                    width: '6px',
                                    height: '6px',
                                    marginTop: '8px'
                                }}
                            ></span>
                        </div>
                        <p className="tw-text-primary">
                            When a cold bed date is blocked on the calendar, all prior dates for cold bed will be blocked.
                        </p>
                    </div>
                </div>
                <div className="">
                    <p className="tw-text-primary tw-font-bold">Flexible Booking</p>
                    <div className="tw-flex tw-flex-row tw-gap-2 tw-ml-2 tw-mb-4">
                        <div className='tw-flex'>
                            <span
                                className="tw-bg-primary bullet"
                                style={{
                                    borderRadius: '9999px',
                                    width: '6px',
                                    height: '6px',
                                    marginTop: '8px'
                                }}
                            ></span>
                        </div>
                        <p className="tw-text-primary">
                            When a cold bed date is blocked on the calendar, all prior dates for cold bed will be blocked.
                        </p>
                    </div>
                    <div className="tw-flex tw-flex-row tw-gap-2 tw-ml-2 tw-mb-4">
                        <div className='tw-flex'>
                            <span
                                className="tw-bg-primary bullet"
                                style={{
                                    borderRadius: '9999px',
                                    width: '6px',
                                    height: '6px',
                                    marginTop: '8px'
                                }}
                            ></span>
                        </div>
                        <p className="tw-text-primary"> When hot bed dates are blocked, those selected dates for hot bed will be blocked.</p>
                    </div>
                    <div className="tw-ml-4">
                        <div className="tw-flex tw-flex-row tw-gap-2 tw-ml-2 tw-mb-4">
                            <div className='tw-flex'>
                                <span
                                    className="tw-bg-primary bullet-2"
                                    style={{
                                        borderRadius: '9999px',
                                        width: '5px',
                                        height: '5px',
                                        marginTop: '8px'
                                    }}
                                ></span>
                             </div>
                            <p className="tw-text-primary">
                                When hot bed dates are blocked, all earlier dates up to the furthest checkout date will be automatically blocked for
                                cold bed.
                            </p>
                        </div>
                        <div className="tw-flex tw-flex-row tw-gap-2 tw-ml-2">
                            <div className='tw-flex'>
                                <span
                                    className="tw-bg-primary bullet-2"
                                    style={{
                                        borderRadius: '9999px',
                                        width: '5px',
                                        height: '5px',
                                        marginTop: '8px'
                                    }}
                                ></span>
                             </div>
                            <p className="tw-text-primary">
                                Example: hot bed dates blocked: 8/20/24-8/28/24 and 9/3/24-9/7/24. Everything prior to 9/7/24 will be blocked for cold
                                bed.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="cs-card"
                style={{
                    padding: '38px 24px 38px 24px',
                }}
            >
                <div className="mb-4">
                    <p className="tw-text-primary tw-font-bold">Recommended:</p>
                    <div className="tw-flex tw-flex-row tw-gap-2 tw-ml-2">
                        <div className='tw-flex'>
                            <span
                                className="tw-bg-primary bullet"
                                style={{
                                    borderRadius: '9999px',
                                    width: '6px',
                                    height: '6px',
                                    marginTop: '8px'
                                }}
                            ></span>
                        </div>
                        <p className="tw-text-primary">
                            For the best results and automated availability tracking, have all current tenants book and pay through the platform.{' '}
                        </p>
                    </div>
                </div>

                <div className="tw-mb-4">
                    <p className="tw-text-primary tw-font-bold">Important:</p>
                    <div className="tw-flex tw-flex-row tw-gap-2 tw-ml-2">
                        <div className='tw-flex'>
                            <span
                                className="tw-bg-primary bullet"
                                style={{
                                    borderRadius: '9999px',
                                    width: '6px',
                                    height: '6px',
                                    marginTop: '8px'
                                }}
                            ></span>
                        </div>
                        <p className="tw-text-primary">
                            If a guest finds your listing through Crewmates, all communication, bookings, and payments must be completed on the
                            platform. Off-platform messaging and payments are not allowed and may result in removal from the site.
                        </p>
                    </div>
                </div>
                <div>
                    <p className="tw-text-primary tw-font-bold">Required:</p>
                    <div className="tw-flex tw-flex-row tw-gap-2 tw-ml-2">
                        <div className='tw-flex'>
                            <span
                                className="tw-bg-primary bullet"
                                style={{
                                    borderRadius: '9999px',
                                    width: '6px',
                                    height: '6px',
                                    marginTop: '8px'
                                }}
                            ></span>
                        </div>
                        <p className="tw-text-primary">
                            If you receive bookings outside the platform (not from Crewmates), you must manually update your calendar to avoid double
                            bookings. Listings with frequent expired or rejected booking requests may be at risk of being unlisted or temporarily
                            suspended from hosting to maintain the quality of the platform.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
